import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import React from 'react';

interface LegalTableProps {
  headers: string[];
  rows: string[][];
}

export const LegalTable: React.FC<LegalTableProps> = ({ headers, rows }) => (
  <TableContainer>
    <Table
      sx={{
        '& .MuiTableCell-root': {
          border: '1px solid #e0e0e0',
          verticalAlign: 'top',
        },
      }}
    >
      <TableHead
        sx={{
          '& .MuiTableCell-root': {
            backgroundColor: '#f0f1f2',
          },
        }}
      >
        <TableRow>
          {headers.map((header) => (
            <TableCell key={header}>{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {rows.map((row, i) => (
          <TableRow key={i}>
            {row.map((cell, j) => (
              <TableCell key={j}>{cell}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
